import React, { useState, useEffect } from "react";
import { 
  announcementBar, headerText, headerLink, closeButton
} from "./style.mod.scss";
import Link from "components/link";

const AnnouncementBar = ({ data }) => {
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    const isClosedFromStorage = sessionStorage.getItem("announcementBarClosed");
    setIsClosed(isClosedFromStorage === "true");
  }, []);

  const handleClose = () => {
    setIsClosed(true);
    sessionStorage.setItem("announcementBarClosed", "true");
  };

  if (!data.show || isClosed) {
    return <></>;
  }

  const wrapperStyle = {};
  if (data.txtColor && data.txtColor.hex) wrapperStyle.color = data.txtColor.hex;
  if (data.bgColor && data.bgColor.hex) wrapperStyle.backgroundColor = data.bgColor.hex;

  const parts = data?.text?.split(/\{([^}]+)\}/);

  return (
    <div className={announcementBar} style={wrapperStyle}>
      <span className={headerText}>
        {parts.map((part, index) => (
          index % 2 === 0 ? part : (
            <React.Fragment key={index}>
              &nbsp;
              <Link className={headerLink} href={data?.url}>
                {part}
              </Link>
            </React.Fragment>
          )
        ))}
      </span>
      <button className={closeButton} onClick={handleClose}>
        X
      </button>
    </div>
  );
};

export default AnnouncementBar;
